import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import { useCallback, useMemo, useState, useEffect } from 'react';
import DashboardTabs from 'components/features/dashboard-tabs';
import { EDashboardTab } from 'components/features/dashboard-tabs/types';
import UWDashboard from '../UWDashboard';
import FinanceDashboard from 'routes/Home/FinanceDashboard';
import MasterClaimsDashboard from '../MasterClaimsDashboard';
import { useLocation } from 'react-router';
import { EPageTo } from 'constants/path';
import { useDashboardFiltersStore } from 'stores/dashboard-filters';

function Dashboard() {
  const { t } = useTranslation();
  const location = useLocation();
  const { to } = location?.state ?? {};
  const [activeTab, setActiveTab] = useState(EDashboardTab.UW);
  const { resetAllDashboardFilters } = useDashboardFiltersStore();

  useEffect(() => {
    if (
      location.state?.activeTab &&
      Object.values(EDashboardTab).includes(location.state.activeTab)
    ) {
      setActiveTab(location.state.activeTab);
    }

    if (to === EPageTo.FINANCE_DASHBOARD) {
      setActiveTab(EDashboardTab.FINANCE);
    }
  }, []);

  const titleByTab = useMemo(
    () => ({
      [EDashboardTab.UW]: t('dashboard.underwriterDashboard'),
      [EDashboardTab.FINANCE]: t('dashboard.financeDashboard'),
      [EDashboardTab.CLAIM]: t('dashboard.claimDashboard'),
    }),
    [t]
  );

  const subtitleByTab = useMemo(
    () => ({
      [EDashboardTab.UW]: t('dashboard.subtitle'),
      [EDashboardTab.FINANCE]: t('dashboard.subtitle'),
      [EDashboardTab.CLAIM]: t('dashboard.masterClaimsSubtitle'),
    }),
    [t]
  );

  const renderDashboardContent = useCallback((activeTab: EDashboardTab) => {
    switch (activeTab) {
      case EDashboardTab.UW:
        return <UWDashboard />;
      case EDashboardTab.FINANCE:
        return <FinanceDashboard />;
      case EDashboardTab.CLAIM:
        return <MasterClaimsDashboard />;
      default:
        return null;
    }
  }, []);

  const handleTabChange = useCallback(
    (tab: EDashboardTab) => {
      resetAllDashboardFilters();
      setActiveTab(tab);
    },
    [resetAllDashboardFilters]
  );

  return (
    <HomeLayout
      title={titleByTab[activeTab]}
      subtitle={subtitleByTab[activeTab]}
      allowBack={false}
    >
      <DashboardTabs activeTab={activeTab} setActiveTab={handleTabChange} />
      {renderDashboardContent(activeTab)}
    </HomeLayout>
  );
}

export default Dashboard;
